const initBlock = function( $block ) {
	$block.find( '.js-faq' ).each( function() {
		const details = this;
		const summary = details.querySelector( 'summary' );
		const answer  = details.querySelector( '.section-faq__answer' );

		summary.addEventListener( 'click', function( e ) {
			e.preventDefault();

			if ( details.open ) {
				answer.style.maxHeight = answer.scrollHeight + 'px';
				answer.style.opacity   = '1';

				answer.getBoundingClientRect();

				answer.style.maxHeight = '0px';
				answer.style.opacity   = '0';

				setTimeout( function() {
					details.removeAttribute( 'open' );
					answer.style.cssText = '';
				}, 420 );

			} else {
				answer.style.maxHeight = '0px';
				answer.style.opacity   = '0';

				details.setAttribute( 'open', '' );

				answer.getBoundingClientRect();

				answer.style.maxHeight = answer.scrollHeight + 'px';
				answer.style.opacity   = '1';

				setTimeout( function() {
					answer.style.cssText = '';
				}, 420 );
			}
		} );
	} );
};

app.loadBlock( initBlock, 'faq', '.section-faq' );

if ( module.hot ) {
	module.hot.accept();
}
